import { useQuery } from "@tanstack/react-query";

import { PageHeader } from "../../components/shell/AppShell";
import { EmptyState, ErrorState, Skeleton, StatusBadge } from "../../components/ui/Feedback";
import { formatDateTime } from "../../lib/format";
import { systemApi } from "../../lib/api";

export function HostsPage() {
  const query = useQuery({
    queryKey: ["system-overview"],
    queryFn: ({ signal }) => systemApi.overview(signal),
    retry: false,
  });
  const agent = query.data?.components.find((component) => component.component === "agent");
  return (
    <div className="page">
      <PageHeader title="Sunucular" />
      {query.isLoading ? (
        <Skeleton />
      ) : query.isError ? (
        <ErrorState
          onRetry={() => {
            void query.refetch();
          }}
        />
      ) : agent?.status === "healthy" ? (
        <section className="card stack">
          <h2>Compose geliştirme agent’ı</h2>
          <StatusBadge status="healthy" />
          <dl>
            <dt>Bağlantı</dt>
            <dd>{agent.summary}</dd>
            <dt>Son doğrulama</dt>
            <dd>{formatDateTime(agent.checkedAt)}</dd>
          </dl>
          <p className="muted">
            Bu kayıt salt okunurdur. Ham sunucu komutu veya kabuk erişimi sunulmaz.
          </p>
        </section>
      ) : (
        <EmptyState
          body="Agent ile doğrulanan sunucular burada görünecek."
          heading="Henüz kayıtlı sunucu yok"
        />
      )}
    </div>
  );
}
